import {FC} from 'react';
import {PAYMENT_METHOD_ICONS, RegistrationPaymentMethod} from '../../../model';
import styles from './PaymentMethodOption.module.css';

type Props = {
	value: RegistrationPaymentMethod;
	label: string;
	onSelect: (value: RegistrationPaymentMethod) => void;
};

export const PaymentMethodOption: FC<Props> = ({value, label, onSelect}) => {
	const Icon = PAYMENT_METHOD_ICONS[value];

	return (
		<button type="button" className={styles.row} onClick={() => onSelect(value)}>
			<span className={styles.iconWrap}>
				<Icon className={styles.icon} />
			</span>
			<span className={styles.label}>{label}</span>
		</button>
	);
};
